import AppLayout from "./Layout";

export default AppLayout;
